/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formvalidation_Estimatedticketsizemax_Min4Inputs */

const en_formvalidation_estimatedticketsizemax_min4 = /** @type {(inputs: Formvalidation_Estimatedticketsizemax_Min4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimated ticket size max. must be greater than or equal to estimated ticket size min.`)
};

/**
* | output |
* | --- |
* | "Estimated ticket size max. must be greater than or equal to estimated ticket size min." |
*
* @param {Formvalidation_Estimatedticketsizemax_Min4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const formvalidation_estimatedticketsizemax_min4 = /** @type {((inputs?: Formvalidation_Estimatedticketsizemax_Min4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formvalidation_Estimatedticketsizemax_Min4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_formvalidation_estimatedticketsizemax_min4(inputs)
});
export { formvalidation_estimatedticketsizemax_min4 as "formValidation_estimatedTicketSizeMax_min" }